module.exports = __webpack_public_path__ + "img/plus-icon.f079fb90.svg";